import { adminHttpClient } from '../../../commons/adminHttpClient'

const updateOfferingRenewalClasses = (
  productClassId: string,
  offer: boolean,
  useSameAsPrevious: boolean,
): Promise<any> => {
  return adminHttpClient.put('/Benefit/BenefitRenewal/Ichra/UpdateOfferingRenewalClasses', {
    productClassId,
    offer,
    useSameAsPrevious,
  })
}

export default updateOfferingRenewalClasses
